// 转换数据格式
function transNum(num) {
  if (num < 10) return `0${num}`;
  return `${num}`;
}

/**
 * @param {Object} options
 * @param {Boolean} [options.serverTimezone=false] 是否设置服务器时区
 */
export const formatTimes = (options = { serverTimezone: false }) => {
  let date = new Date();
  if (options.serverTimezone) {
    // 换算成东八区时间
    const timezoneOffset = date.getTimezoneOffset(); // 距离UTC时区偏移分钟
    const timezoneOffsetDiff = timezoneOffset - (-480); // 比东八区慢xx分钟数
    const beijingTimezongStamp = date.getTime() + timezoneOffsetDiff * 60000;
    date = new Date(beijingTimezongStamp);
  }
  const currentdate = transNum(date.getMonth() + 1)
    + transNum(date.getDate())
    + transNum(date.getHours())
    + transNum(date.getMinutes())
    + transNum(date.getSeconds());
  return currentdate;
};

export const timer = (options = {}, fun, timerMes = {}) => {
  timerMes.id = setTimeout(timer.bind(this, options, fun, timerMes), options.time || 1000);
  timerMes.clear = timerMes.clear || function () {
    clearTimeout(timerMes.id);
  };
  if (options.immediateFirst !== false) {
    fun();
  } else {
    options.immediateFirst = '';
  }
  return timerMes;
};
export const randomn = (n) => {
  if (n > 21) return null;
  const re = new RegExp(`(\\d{${n}})(\\.|$)`);
  const num = (Array(n - 1).join(0) + Math.pow(10, n) * Math.random()).match(re)[1];
  return num;
};
